import { render } from "./App.vue?vue&type=template&id=2944bd24"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2944bd24&lang=css"
script.render = render

export default script